<template>
  <article class="mb-12">
    <SwiperImages
            :img-class="imgClass"
            :img-dimensions="imgDimensions"
            :img-sizes="imgSizes"
            :items="images"
            :picture-class="pictureClass"
            class="mb-6"
    />
    <header class="mb-4">
      <h3 class="page-title text-grey mb-2">{{ title }}</h3>
      <h4
              v-if="subtitle"
              class="text-base text-grey">
        {{ subtitle }}
      </h4>
    </header>
    <MDC :value="content" class="text-grey mb-4"/>
    <small
            v-if="location"
            class="text-sm text-grey/70 inline-flex items-center">
      <IconLocation class="size-3 me-1"/>
      {{ location }}
    </small>
  </article>
</template>
<script lang="ts" setup>
import SwiperImages from "~/components/swiper/SwiperImages.vue";

const {
    title,
    subtitle = '',
    content,
    location = '',
    itemKey,
    imgSizes = '100vw, (min-width: 767px) 50vw',
    pictureClass = '',
    imgClass = '',
    imgDimensions = [
        {width: 480},
        {width: 960},
        {width: 1440},
        {width: 1920},
    ],
} = defineProps<{
    itemKey: string,
    title: string,
    content: string,
    subtitle?: string,
    location?: string,
    pictureClass?: string;
    imgClass?: string;
    imgDimensions?: { width: number, height?: number }[];
    imgSizes?: string;
}>();
const slug = `pro/references/${itemKey}`;
const {data: images} = await useFetch('/api/getAssetImages', {
    query: {
        slug,
        withSize: 'y',
    },
    default: () => []
});
</script>
